export const DESCRIPTION =
  "Let’s Be Friends. Sign up for exclusive offers & first access to new releases—plus, you’ll even get 10% off your first order.";
export const THANKYOU = "Welcome to the community! Check your email for 10% off your first order.";
export const DISCLAIMER =
  "By subscribing, you agree to receive recurring automated marketing text messages at the phone number provided. Consent is not a condition of purchase. Reply STOP to unsubscribe, HELP for help. Msg & data rates may apply.";
